/* eslint-disable local/ensure-wac-token-usage */

import { css } from "@compiled/react";

import { Picture } from "@/components/wpl/image/src/image";
import { Row } from "@/libraries/wpl/foundations/src/grid";

/**
 * @deprecated - Please use @/libraries/design/components/pull-quote instead
 */
export type PullQuoteProps = {
    readonly logoSrc?: string;
    readonly logoAltText?: string;
    readonly quoteBlurb: string;
    readonly quoteName: string;
    readonly quoteCompany: string;
    readonly isShowBorder?: boolean;
    readonly isUsingTextQuotationMarks?: boolean;
    readonly isSmall?: boolean;
};

const pullQuoteCss = css({
    "paddingBlockStart": "32px",
    "paddingBlockEnd": "32px",

    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between",
    "alignItem": "center",
    "alignContent": "center",
    "@media (min-width: 48rem)": {
        flexDirection: "row"
    }
});

const borderCss = css({
    borderBlockStart: "1px solid #ebecf0",
    borderBlockEnd: "1px solid #ebecf0"
});

const smallBorderCss = css({
    borderBlockStart: "1px solid #D9D9D9",
    borderBlockEnd: "1px solid #D9D9D9"
});

const smallWidthCss = css({
    width: "75%",
    justifySelf: "center"
});

const quoteCss = css({
    textAlign: "left"
});

const quotationMarkStyle = {
    height: "24px"
};

const quoteBlurbCss = css({
    "fontSize": "20px",
    "lineHeight": "28px",
    "fontWeight": "100",
    "@media (min-width: 48rem)": {
        fontSize: "28px",
        lineHeight: "40px"
    }
});

const nameAndCompanyContainerCss = css({
    display: "flex",
    flexDirection: "column",
    height: "80%",
    justifyContent: "space-between"
});

const quoteNameCss = css({
    margin: "0",
    fontWeight: "bold",
    fontSize: "16px",
    lineHeight: "24px"
});

const smallQuoteNameCss = css({
    margin: "0",
    fontWeight: "800",
    fontSize: "12px",
    lineHeight: "22px",
    textTransform: "uppercase"
});

const quoteCompanyCss = css({
    margin: "0",
    fontSize: "16px",
    lineHeight: "24px"
});

const smallQuoteCompanyCss = css({
    margin: "0",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "22px",
    textTransform: "uppercase"
});

const pullQuoteImgContainerCss = css({
    "textAlign": "center",
    "padding": "16px",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "marginBlockEnd": "32px",
    "marginInlineEnd": "0px",
    "@media (min-width: 48rem)": {
        marginBlockEnd: "0px",
        marginInlineEnd: "32px"
    }
});

const pullQuoteImgCss = css({
    "objectFit": "scale-down",
    "height": "200px",
    "width": "100%",
    "@media (min-width: 48rem)": {
        height: "100%",
        width: "180px"
    },
    "@media (min-width: 64rem)": {
        width: "220px"
    }
});

/**
 * @deprecated - Please use @/libraries/design/components/pull-quote instead
 */
export const PullQuote = ({
    logoSrc,
    logoAltText,
    quoteBlurb,
    quoteName,
    quoteCompany,
    isShowBorder = false,
    isUsingTextQuotationMarks = false,
    isSmall = false
}: // eslint-disable-next-line complexity
PullQuoteProps) => {
    const isShowQuoteLogo = !!logoSrc;

    return (
        <Row layout="10">
            <div
                css={[
                    pullQuoteCss,
                    isShowBorder && !isSmall && borderCss,
                    isShowBorder && isSmall && smallBorderCss,
                    isSmall && smallWidthCss
                ]}
            >
                {isShowQuoteLogo && (
                    <div css={pullQuoteImgContainerCss}>
                        {/* eslint-disable-next-line no-restricted-syntax */}
                        <img
                            css={pullQuoteImgCss}
                            src={logoSrc || ""}
                            alt={logoAltText || ""}
                        />
                    </div>
                )}
                <div css={quoteCss}>
                    {!isUsingTextQuotationMarks && (
                        <Picture
                            style={quotationMarkStyle}
                            image={{
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/41knb7g4sf3cg6sj54o2uubv0r3r3n33.svg",
                                alt: "Quotation mark"
                            }}
                        />
                    )}
                    <div css={nameAndCompanyContainerCss}>
                        <p
                            css={[
                                isSmall
                                    ? css({ color: "#344563" })
                                    : quoteBlurbCss
                            ]}
                            className={isSmall ? "body-sm" : ""}
                        >
                            {isUsingTextQuotationMarks ? "“" : ""}
                            {quoteBlurb}”
                        </p>
                        <div>
                            <p
                                css={[
                                    isSmall ? smallQuoteNameCss : quoteNameCss
                                ]}
                            >
                                {quoteName}
                            </p>
                            <p
                                css={[
                                    isSmall
                                        ? smallQuoteCompanyCss
                                        : quoteCompanyCss
                                ]}
                            >
                                {quoteCompany}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Row>
    );
};
